var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 226.485,
    height: 189.485,
    viewBox: "0 0 226.485 189.485",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:url(#b);}.c{fill:#4d8af0;}.c,.d,.e,.f{opacity:0.5;}.d{fill:#f55f44;}.e,.g{fill:#47e6b1;}.h{fill:rgba(29,29,29,0.11);}.i{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d05165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ac3044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cd384f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9415a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-572 -278.54)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18.455 -9.182)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M64.5,129.01A64.21,64.21,0,0,1,28.44,117.993,64.7,64.7,0,0,1,5.069,89.613,64.415,64.415,0,0,1,11.017,28.44,64.686,64.686,0,0,1,39.4,5.069,64.1,64.1,0,0,1,64.5,0c.747,0,1.5.013,2.246.038L64.982,129.008H64.5Z",
    transform: "translate(680.389 292.885) rotate(30)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0A64.5,64.5,0,0,1,64.5,64.5,64.5,64.5,0,0,1,0,129.01Z",
    transform: "translate(736.252 325.138) rotate(30)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(590.45 287.721)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M326.542,109.054a.968.968,0,0,1-.54-1.17.467.467,0,0,0,.021-.107h0a.486.486,0,0,0-.872-.322h0a.465.465,0,0,0-.054.1.968.968,0,0,1-1.17.54.466.466,0,0,0-.107-.021h0a.486.486,0,0,0-.322.872h0a.465.465,0,0,0,.1.054.968.968,0,0,1,.54,1.17.464.464,0,0,0-.021.107h0a.486.486,0,0,0,.872.322h0a.466.466,0,0,0,.054-.1.968.968,0,0,1,1.17-.54.465.465,0,0,0,.107.021h0a.486.486,0,0,0,.322-.872h0A.465.465,0,0,0,326.542,109.054Z",
    transform: "translate(-282.979 -96.415)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M180.542,434.054a.968.968,0,0,1-.54-1.17.466.466,0,0,0,.021-.107h0a.486.486,0,0,0-.872-.322h0a.466.466,0,0,0-.054.1.968.968,0,0,1-1.17.54.467.467,0,0,0-.107-.021h0a.486.486,0,0,0-.322.872h0a.466.466,0,0,0,.1.054.968.968,0,0,1,.54,1.17.466.466,0,0,0-.021.107h0a.486.486,0,0,0,.872.322h0a.465.465,0,0,0,.054-.1.968.968,0,0,1,1.17-.54.465.465,0,0,0,.107.021h0a.486.486,0,0,0,.322-.872h0A.465.465,0,0,0,180.542,434.054Z",
    transform: "translate(-175.456 -335.765)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 1.581,
    cy: 1.581,
    r: 1.581,
    transform: "translate(195.655 65.358)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 1.581,
    cy: 1.581,
    r: 1.581,
    transform: "translate(30.415 178.416)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 1.581,
    cy: 1.581,
    r: 1.581,
    transform: "translate(222.536 126.236)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M865.543,138.054a.968.968,0,0,1-.54-1.17.467.467,0,0,0,.021-.107h0a.486.486,0,0,0-.872-.322h0a.462.462,0,0,0-.054.1.968.968,0,0,1-1.17.54.465.465,0,0,0-.107-.021h0a.486.486,0,0,0-.322.872h0a.466.466,0,0,0,.1.054.968.968,0,0,1,.54,1.17.464.464,0,0,0-.021.107h0a.486.486,0,0,0,.872.322h0a.468.468,0,0,0,.054-.1.968.968,0,0,1,1.17-.54.466.466,0,0,0,.107.021h0a.486.486,0,0,0,.322-.872h0A.465.465,0,0,0,865.543,138.054Z",
    transform: "translate(-679.931 -117.773)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M965.543,766.054a.968.968,0,0,1-.54-1.17.463.463,0,0,0,.021-.107h0a.486.486,0,0,0-.872-.322h0a.467.467,0,0,0-.054.1.968.968,0,0,1-1.17.54.463.463,0,0,0-.107-.021h0a.486.486,0,0,0-.322.872h0a.468.468,0,0,0,.1.054.968.968,0,0,1,.54,1.17.463.463,0,0,0-.021.107h0a.486.486,0,0,0,.872.322h0a.461.461,0,0,0,.054-.1.968.968,0,0,1,1.17-.54.464.464,0,0,0,.107.021h0a.486.486,0,0,0,.322-.872h0A.467.467,0,0,0,965.543,766.054Z",
    transform: "translate(-753.577 -580.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M173.542,244.054a.968.968,0,0,1-.54-1.17.466.466,0,0,0,.021-.107h0a.486.486,0,0,0-.872-.322h0a.465.465,0,0,0-.054.1.968.968,0,0,1-1.17.54.465.465,0,0,0-.107-.021h0a.486.486,0,0,0-.322.872h0a.466.466,0,0,0,.1.054.968.968,0,0,1,.54,1.17.465.465,0,0,0-.021.107h0a.486.486,0,0,0,.872.322h0a.466.466,0,0,0,.054-.1.968.968,0,0,1,1.17-.54.466.466,0,0,0,.107.021h0a.486.486,0,0,0,.322-.872h0A.466.466,0,0,0,173.542,244.054Z",
    transform: "translate(-170.3 -195.838)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 1.581,
    cy: 1.581,
    r: 1.581,
    transform: "translate(19.347 73.264)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 1.581,
    cy: 1.581,
    r: 1.581,
    transform: "translate(223.327 85.914)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "translate(151.907)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 0.791,
    height: 4.48,
    transform: "translate(1.845)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 0.791,
    height: 4.48,
    transform: "translate(4.48 1.845) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "translate(154.806 175.518)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 0.791,
    height: 4.48,
    transform: "translate(1.845)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 0.791,
    height: 4.48,
    transform: "translate(4.48 1.845) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "translate(5.116 185.005)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 0.791,
    height: 4.48,
    transform: "translate(1.845)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 0.791,
    height: 4.48,
    transform: "translate(4.48 1.845) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "translate(195.113 108.362)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 0.791,
    height: 4.48,
    transform: "translate(1.845)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 0.791,
    height: 4.48,
    transform: "translate(4.48 1.845) rotate(90)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M793.629,117.481l1.7,1.556,2.406-3.538.849.708-3.255,4.245-2.406-2.689Z",
    transform: "translate(-583.951 -85.061)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M30.179,39.555,10.548,59.186,1.172,49.81,20.8,30.179,0,9.376,9.376,0l20.8,20.8L50.982,0l9.376,9.376-20.8,20.8L59.186,49.81l-9.375,9.376Z",
    transform: "translate(81.168 62.989)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M30.179,39.555,10.548,59.186,1.172,49.81,20.8,30.179,0,9.376,9.376,0l20.8,20.8L50.982,0l9.376,9.376-20.8,20.8L59.186,49.81l-9.375,9.376Z",
    transform: "translate(84.483 62.16)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.4ee621b099279c1dda6930cac9064d16.svg";
export { ForwardRef as ReactComponent };